export default "__VITE_ASSET__D3fhIaY3__"